import React from 'react';
import AuthFormGlobalStyle from './AuthFormGlobalStyle';
import DynamicAppStyle from './DynamicAppStyle';
import FontFace from './FontsFace';
import GeneralStyle from './GeneralStyle';
import GeneralStyleV2 from './GeneralStyleV2';
import ResponsiveStyle from './ResponsiveStyle';
import SafariStyle from './SafariStyle';
import './static/utilities.css';
import './static/vendor.css';

/**
 * Core styles loaded on every page. Route- or feature-specific styles are
 * injected via DeferredAppStyles in App.tsx (translator, Freshchat, auth shell).
 */
const Style: React.FC = function Style() {
  return (
    <>
      <FontFace />
      <GeneralStyle />
      <GeneralStyleV2 />
      <ResponsiveStyle />
      <AuthFormGlobalStyle />
      <DynamicAppStyle />
      <SafariStyle />
    </>
  );
};

export default Style;
